import styled from 'styled-components'

interface IButtonProps {
  disabled?: boolean
}

export const Button = styled.button<IButtonProps>`
  width: 40px;
  height: 40px;
  background: ${({ disabled, theme }) => (disabled ? theme.colors.colorb9c2ce : theme.colors.color378ff7)} 0% 0%
    no-repeat padding-box;
  border: none;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`

export const CopyIconWrapper = styled.div`
  svg {
    stroke: ${({ theme }) => theme.zds.colors.neutral1000};
    width: 24px;
    height: 24px;
  }
`

export const CopyAltIconWrapper = styled(CopyIconWrapper)`
  svg {
    rect {
      fill: ${({ theme }) => theme.zds.colors.neutral1000};
    }
  }
`
